import { render, staticRenderFns } from "./Act004MinigameMatch3.vue?vue&type=template&id=4763e2d6&scoped=true"
import script from "./Act004MinigameMatch3.vue?vue&type=script&lang=js"
export * from "./Act004MinigameMatch3.vue?vue&type=script&lang=js"
import style0 from "./Act004MinigameMatch3.vue?vue&type=style&index=0&id=4763e2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4763e2d6",
  null
  
)

export default component.exports